<template>
  <div>
    <div
      v-if="isNewVersionEnabled"
      class="bg-static-info-low rounded-lg mb-16 flex items-center justify-between p-24"
    >
      <FormattedMessage :definition="translations.newVersionTitle">
        <template #link>
          <RevLink :to="{ name: ROUTE_NAMES.OPTIONS.SHIPPING }">
            {{ i18n(translations.newVersionLink) }}
          </RevLink>
        </template>
      </FormattedMessage>
    </div>

    <div
      :class="{
        'grid grid-cols-2 gap-16':
          isFeatureEnabled('backshipEnabled') &&
          isFeatureEnabled('backpackEnabled'),
      }"
    >
      <BlockBackpack v-if="isFeatureEnabled('backpackEnabled')" />
      <BlockBackship v-if="isFeatureEnabled('backshipEnabled')" />
    </div>

    <h2 class="heading-2 mb-20 mt-28">
      {{ i18n(translations.title) }}
    </h2>

    <RevLoadingScreen
      v-if="pending"
      class="h-[60vh]"
      :text="i18n(translations.loading)"
    />

    <ul
      v-if="!pending && data"
      :aria-label="i18n(translations.listPerMarket)"
      class="list-none space-y-32"
    >
      <li
        v-for="shippingMethod in data.shippingMethods"
        :key="shippingMethod.market"
      >
        <ShippingCard
          :shippingMethod
          @deleted="handleDeleted"
          @edited-or-created="handleEditedOrCreated"
        />
      </li>
    </ul>

    <ShippingModalOnboarding />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { merchantsAPI } from '@backmarket/http-api'
import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'
import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevLink } from '@ds/components/Link'
import { RevLoadingScreen } from '@ds/components/LoadingScreen'

import { ROUTE_NAMES } from '~/constants/routes'
import { useBusinessFeaturesStore } from '~/scopes/config/stores/businessFeaturesStore'

import translations from './ShippingLegacy.translations'
import BlockBackpack from './components/BlockBackpack/BlockBackpack.vue'
import BlockBackship from './components/BlockBackship/BlockBackship.vue'
import ShippingCard from './components/ShippingCard/ShippingCard.vue'
import ShippingModalOnboarding from './components/ShippingModalOnboarding/ShippingModalOnboarding.vue'
import { useMetaData } from './composables/useMetaData'

const i18n = useI18n()
const { isFeatureEnabled } = useBusinessFeaturesStore()
// Pre-fetch the meta-data used in the form
useMetaData()

const { data, pending, refresh } = useHttpFetch(merchantsAPI.getShippingMethods)

function handleDeleted() {
  refresh()
}
function handleEditedOrCreated() {
  refresh()
}

const isNewVersionEnabled = computed(() => {
  return isFeatureEnabled('revampedDeliveryMethodsEnabled')
})
</script>
